// Shared by the public React page and its initial-HTML renderer.
module.exports = {
  path: '/services/ai-agent-implementation',
  title: 'AI Agent Implementation Services | DataBackfill',
  description: 'Move an AI workflow from prototype to a scoped production implementation. Plan integrations, human approvals, evaluation, operating costs, and handover with DataBackfill.',
};
